import commonConstant from '../../common/_commonConstant';

export const searchVehiclePlateOrCompanyNameInBuilding = (state, action) => {
  switch (action.type) {
    case commonConstant.SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SEARCH_VEHICLE_PLATE_OR_COMPANY_NAME_IN_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const accountingSearchVehiclePlateOrReferenceCode = (state, action) => {
  switch (action.type) {
    case commonConstant.ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.ACCOUNT_SEARCH_VEHICLE_PLATE_OR_REFERENCE_CODE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const searchVehiclePlateOrParkingRefInOperationReport = (state, action) => {
  switch (action.type) {
    case commonConstant.SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SEARCH_VEHICLE_PLATE_OR_PARKING_REF_IN_OPERATION_REPORT_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const searchVehicleType = (state, action) => {
  switch (action.type) {
    case commonConstant.SEARCH_VEHICLE_TYPE_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SEARCH_VEHICLE_TYPE_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const searchVehiclePlate = (state, action) => {
  switch (action.type) {
    case commonConstant.SEARCH_VEHICLE_PLATE_IN_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SEARCH_VEHICLE_PLATE_IN_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const searchCompanyName = (state, action) => {
  switch (action.type) {
    case commonConstant.SEARCH_COMPANY_NAME_IN_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SEARCH_COMPANY_NAME_IN_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};

export const searchMemberName = (state, action) => {
  switch (action.type) {
    case commonConstant.SEARCH_MEMBER_NAME_IN_BUILDING_SUCCESS:
      return Object.assign({}, state, { ...action });
    case commonConstant.SEARCH_MEMBER_NAME_IN_BUILDING_FAILURE:
      return Object.assign({}, state, { ...action });
    case commonConstant.LOGIN_SUCCESS:
      return {};
    case commonConstant.LOGIN_FAILURE:
      return {};
    case commonConstant.LOGOUT_SUCCESS:
      return {};
    case commonConstant.LOGOUT_FAILURE:
      return {};
    default:
      return state ? state : {};
  }
};
